export type NoteId = 'do' | 're' | 'mi' | 'fa' | 'sol' | 'la' | 'si' | 'rest';

export type NoteFigure =
  | 'redonda'
  | 'blanca'
  | 'negra'
  | 'corchea'
  | 'semicorchea';

export type CellShape = 'circle' | 'square';

export interface NoteColors {
  do: string;
  re: string;
  mi: string;
  fa: string;
  sol: string;
  la: string;
  si: string;
  rest: string;
}

export interface PatternCell {
  note: NoteId;
}

/** Un tiempo del compás (puede abarcar varios pulsos con blanca/redonda) */
export interface BeatSlot {
  active: boolean;
  figure: NoteFigure;
  /** Cuántos tiempos del compás ocupa (1 = negra, 2 = blanca, etc.) */
  span: number;
  cells: PatternCell[];
  /** Incrementa al subdividir para animar */
  subdivideKey: number;
}

export interface Measure {
  slots: BeatSlot[];
}

export interface Pattern {
  beatsPerMeasure: number;
  measures: Measure[];
}

export const NOTE_LABELS: Record<NoteId, string> = {
  do: 'Do',
  re: 'Re',
  mi: 'Mi',
  fa: 'Fa',
  sol: 'Sol',
  la: 'La',
  si: 'Si',
  rest: '—',
};

export const FIGURE_LABELS: Record<NoteFigure, string> = {
  redonda: 'Redonda',
  blanca: 'Blanca',
  negra: 'Negra',
  corchea: 'Corchea',
  semicorchea: 'Semicorchea',
};

/** Duración en unidades de negra (4/4) */
export const FIGURE_BEATS: Record<NoteFigure, number> = {
  redonda: 4,
  blanca: 2,
  negra: 1,
  corchea: 0.5,
  semicorchea: 0.25,
};

export type DrumId = 'kick' | 'snare' | 'hihat' | 'shaker';

export interface DrumPattern {
  enabled: boolean;
  /** Compases del loop (semicorcheas = 16 pasos por compás). */
  measures: number;
  steps: Record<DrumId, boolean[]>;
}

export const DRUM_IDS: DrumId[] = ['kick', 'snare', 'hihat', 'shaker'];

export const DRUM_LABELS: Record<DrumId, string> = {
  kick: 'Kick',
  snare: 'Snare',
  hihat: 'Hi-hat',
  shaker: 'Shaker',
};

export const DRUM_COLORS: Record<DrumId, string> = {
  kick: '#e53935',
  snare: '#1e88e5',
  hihat: '#fdd835',
  shaker: '#43a047',
};

/** Pasos por compás en la grilla (semicorcheas en 4/4). */
export const DRUM_STEPS_PER_MEASURE = 16;

export type ChordId = 'do' | 're' | 'mi' | 'fa' | 'sol' | 'la' | 'si';

export interface MeasureChordGrid {
  steps: Record<ChordId, boolean[]>;
}

export interface ChordAccompaniment {
  enabled: boolean;
  measures: MeasureChordGrid[];
  /** Frecuencias Hz por acorde; si falta, usa la tríada por defecto. */
  voicings?: Partial<Record<ChordId, number[]>>;
}
